import i18n from '../../locales/index';
import { useAuthStore } from '../store/shared/auth-store';
const t = i18n.global.t;

export const marketplacesOptions = [
    {
        id: 1,
        label: t('channels.amazon'),
    },
    // {
    // 	id: 2,
    // 	label: t('channels.amazon'),
    // },
    {
        id: 3,
        label: t('channels.salla'),
    },
    {
        id: 4,
        label: t('channels.google'),
    },
    {
        id: 5,
        label: t('channels.facebook'),
    },
    {
        id: 6,
        label: t('channels.shopify'),
    },
    {
        id: 7,
        label: t('channels.zid'),
    },
    {
        id: 8,
        label: t('channels.whatsapp'),
    },
    {
        id: 9,
        label: t('channels.noon'),
    },
    {
        id: 12,
        label: t('channels.trendyol'),
    },
    {
        id: 14,
        label: t('channels.instagram'),
    },
    {
        id: 15,
        label: t('channels.odoo'),
    },
    {
        id: 16,
        label: t('channels.whatsapp-qr'),
    },
    {
        id: 17,
        label: t('channels.messenger'),
    },
    {
        id: 18,
        label: t('channels.woocommerce'),
    },
];

export const marketplacesEnum = Object.freeze({
    Amazon: 1,
    Salla: 3,
    Google: 4,
    Facebook: 5,
    Shopify: 6,
    Zid: 7,
    WhatsApp: 8,
    Noon: 9,
    Trendyol: 12,
    CustomApp: 13,
    Instagram: 14,
    Odoo: 15,
    WhatsAppQR: 16,
    Messenger: 17,
    WooCommerce: 18,
});

export const getMarketplace = (id) => {
    return marketplacesOptions.find((p) => p.id == id);
};

export const hasMarketplace = (id) => {
    const authStore = useAuthStore();
    return authStore.linkedMarketPlaces.includes(id);
};

const m = marketplacesEnum;
export const marketplacesMetadata = Object.freeze({
    canCreateReturnByItem: [m.Amazon, m.Salla, m.Shopify, m.WhatsApp, m.Trendyol, m.WooCommerce], // can choose items when create order return
    canAcceptRejectReturnItem: [m.Amazon, m.Salla, m.Shopify, m.WhatsApp, m.Trendyol, m.WooCommerce], // can accept or reject return items one by one
    canAcceptRejectOrderReturn: [m.Zid], // can accept or reject the whole order return at the same time
});

export const getMarketplaceMeta = (marketplaceId) => {
    const metadata = {};
    Object.keys(marketplacesMetadata).forEach((key) => {
        if (marketplacesMetadata[key].includes(marketplaceId)) {
            metadata[key] = true;
        } else {
            metadata[key] = false;
        }
    });
    // console.log('🚀 ~ getMarketplaceMeta ~ metadata:', marketplaceId, metadata);
    return metadata;
};
